import React from 'react';
import styled from 'styled-components';

import Picture from '../image/CloudFrontPicture';
import Caption from '../common/FigCaption';

const StyledFigure = styled.figure`
    
`

const SewpatPartsImage = ({ sewpat }) => {

    return (
        <StyledFigure>
            <Picture
                webp={sewpat.parts.wepb}
                src={sewpat.parts.src}
                alt={sewpat.parts.alt}
                schnoffle
                path={`schnittmuster/${sewpat.id}`}
            />
            <Caption>Abb: {sewpat.parts.caption}</Caption>
        </StyledFigure>
    );
};

export default SewpatPartsImage;



// WEBPACK FOOTER //
// ./src/components/sewpat/SewpatPartsImage.js